import {toast} from '@common-web/hooks/use-toast';

/**
 * Job ids we've already kicked off a download for. The same completed export can
 * be observed by both the export dialog (while open) and the background banner
 * poll (after "Run in background"); this module-level set guarantees the browser
 * download + toast fire exactly once per job regardless of which one sees it
 * first. It intentionally outlives component mounts (survives closing the dialog
 * / navigating between Member Search and Group Members) for the session.
 */
const downloadedExportJobIds = new Set<string>();

/**
 * Trigger the browser download for a completed member export and toast the user.
 * No-ops (returns `false`) if this job already triggered a download, so callers
 * can invoke it freely on every COMPLETED poll without double-downloading.
 */
export function triggerMemberExportDownload(
  jobRunId: string,
  downloadUrl: string,
  fileName: string | null,
): boolean {
  if (downloadedExportJobIds.has(jobRunId)) return false;
  downloadedExportJobIds.add(jobRunId);

  // `noopener,noreferrer` keeps the new tab from inheriting the opener; S3 sets
  // `Content-Disposition: attachment` so the tab closes as the download starts.
  window.open(downloadUrl, '_blank', 'noopener,noreferrer');
  toast({
    title: 'Export ready',
    description: `${fileName ?? 'Member export'} is downloading now.`,
  });
  return true;
}
